"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadProgressRing = UploadProgressRing;
var jsx_runtime_1 = require("react/jsx-runtime");
function UploadProgressRing(props) {
    var percent = props.percent, size = props.size;
    var STROKE_WIDTH = 4;
    var radius = (size - STROKE_WIDTH) / 2;
    var circumference = 2 * Math.PI * radius;
    var offset = circumference * (1 - Math.min(Math.max(percent, 0), 100) / 100);
    return ((0, jsx_runtime_1.jsxs)("svg", { width: size, height: size, className: "absolute inset-0 -rotate-90", "aria-label": "Uploading ".concat(percent, "%"), role: "img", children: [(0, jsx_runtime_1.jsx)("circle", { cx: size / 2, cy: size / 2, r: radius, fill: "none", stroke: "currentColor", strokeWidth: STROKE_WIDTH, className: "text-light-gray" }), (0, jsx_runtime_1.jsx)("circle", { cx: size / 2, cy: size / 2, r: radius, fill: "none", stroke: "currentColor", strokeWidth: STROKE_WIDTH, strokeDasharray: circumference, strokeDashoffset: offset, strokeLinecap: "round", className: "text-primary-navy transition-[stroke-dashoffset]" })] }));
}
